module.exports = __webpack_public_path__ + "static/media/search.d844e244.svg";